import React from 'react';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
// import gql from 'graphql-tag';
// import { withApollo } from 'react-apollo';
import { Link } from 'react-router';
// import styled from 'styled-components';
// import FontAwesomeIcon from '@fortawesome/react-fontawesome';
// import faSearch from '@fortawesome/fontawesome-pro-light/faSearch';
import immutableCreatorSelector from '../../../../../../selectors/immutableCreatorSelector';
import { AuthActions } from '../../../../../../actions/auth';
import {
  currentProjectIdSelector,
  projectsSelector,
} from '../../../../../../reducers/projects';
import { currentUserSelector } from '../../../../../../reducers/users';

const CurrentProjectIdSelector = immutableCreatorSelector(
  [currentProjectIdSelector, projectsSelector, currentUserSelector],
  (currentProjectId, projects, currentUser) => ({
    currentProjectId,
    projects,
    currentUser
  }),
);

@connect(CurrentProjectIdSelector)
class SearchModal extends React.Component {
  state = {
    results: [],
  };

  debouncedFetch = debounce(async () => {
    await this.getElements(this.state.value);
  }, 250);

  handleOnChange = option => {
    // const { dispatch, currentProjectId } = this.props;
    // const url = `/project/${currentProjectId}/element/${option.value}`;
    // dispatch(push(url));
  };

  handleChange = event => {
    this.setState({ value: event.target.value }, this.debouncedFetch);
  };

  // isUnassignedButAccAdmin = (projectId, currentUserId) => {
  //   const { users, currentUser } = this.props;
  //   const isAccountAdmin =
  //     users.getIn([currentUserId, 'roles', 'account', accountId]) <= 2;
  //   const isAssignedToProject = currentUser.getIn([
  //     'roles',
  //     'project',
  //     projectId,
  //   ]);
  //   return isAccountAdmin && !isAssignedToProject;
  // };

  getElements = async input => {
    const { projects } = this.props;

    if (!projects && projects.get('projects')) {
      return;
    }

    const results = projects.get('projects').filter(p => {
      return (
        p
          .get('name')
          .toLowerCase()
          .indexOf(input.toLowerCase()) > -1 && p.get('is_suspended') !== true
      );
    });

    this.setState({
      results: results
        .sortBy(p => p.get('name'))
        .map(p => p)
        .valueSeq()
        .toArray(),
    });
  };

  componentDidMount() {
    this.searchInput.focus();
    const { dispatch } = this.props;
    dispatch(AuthActions.getMeProjects());
  }

  handleClick = () => {
    const { closePortal } = this.props;
    closePortal();
  };

  render() {
    const { projects } = this.props;
    const { results } = this.state;

    const searchResults =
      results.length > 0
        ? results
        : projects
            .get('projects')
            .filter(p => {
              return p.get('is_suspended') !== true;
            })
            .toArray();

    return (
      <div>
        <input
          ref={input => (this.searchInput = input)}
          type="text"
          className="form-control"
          onChange={this.handleChange}
          style={{ marginBottom: 5, fontSize: 20, border: 0 }}
          placeholder="Search Projects..."
        />
        <div className="list-group list-group-flush">
          {searchResults.map(result => (
            <li
              key={result.get('id')}
              className="list-group-item flex-column align-items-start"
            >
              <div className="d-flex w-100 justify-content-between">
                <Link
                  to={`/project/${result.get('id')}`}
                  onClick={this.handleClick}
                >
                  <h5 className="mb-1">{result.get('name')}</h5>
                </Link>
                {/* <small>3 days ago</small> */}
              </div>
              <p className="mb-1">{result.get('description')}</p>
              {/* <small>Donec id elit non mi porta.</small> */}
            </li>
          ))}
        </div>
      </div>
    );
  }
}

export default SearchModal;



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/industry/construction/SwitchProjectsIcon/SearchModal.js